import {commerceProduct,COMMERCE,type CommerceProduct} from '../src/commerce-types';
import {APP_BASE,Link} from './router';
import assets from './service-descriptors.json';
import './service-brand.css';

export function serviceAtPath(path:string):CommerceProduct|undefined {
 return COMMERCE.products.find(product=>[product.publicPath,product.accountPath].some(route=>path===route||path.startsWith(route+'/')))?.id as CommerceProduct|undefined;
}
export function ServiceBrand({product,size='header',linked=false}:{product:CommerceProduct;size?:'header'|'hero'|'checkout';linked?:boolean}) {
 const asset=assets[product][size],label=commerceProduct(product).name;
 const mobile=assets[product].heroMobile;
 const content=<><span className="service-brand-word" aria-hidden="true">EIGHTBOTS</span><picture>
  {size==='hero'&&<source media="(max-width:650px)" srcSet={APP_BASE+mobile.src} width={mobile.width} height={mobile.height}/>}
  <img src={APP_BASE+asset.src} width={asset.width} height={asset.height} alt="" aria-hidden="true"/>
 </picture></>;
 return linked?<Link href={`${APP_BASE}${commerceProduct(product).publicPath}`} aria-label={label} className={`service-brand service-brand-${size}`}>{content}</Link>:
  <div className={`service-brand service-brand-${size}`} role="img" aria-label={label}>{content}</div>;
}
